import React, { Component } from "react";
import "./App.css";
import { validate } from "uuid";
import logo from "./images/confia-logo.svg";
import btnx from "./images/botao_x.png";
import Loading from "./containers/Loading";
import Page404 from "./containers/Page404";
import Page500 from "./containers/Page500";
import Terms from "./containers/Terms";
import AuthenticateFace from "./containers/AuthenticateFace";
import DocumentViewer from "./containers/DocumentViewer";
import DocumentNotSigned from "./containers/DocumentNotSigned";
import DocumentSigned from "./containers/DocumentSigned";
import Refused from "./containers/Refused";
import LoadingTerm from "./containers/LoadingTerm";
import RegistrationFace from "./containers/RegistrationFace";
import Capture from "./containers/Capture";
import DocumentIsSigned from "./containers/DocumentIsSigned";
import api from "./containers/api";
import Info from "./containers/Info";
import ErrorGeneric from "./containers/ErrorGeneric";
import ValidationConfirmed from "./containers/ValidationConfirmed";
import DocumentSignedList from "./containers/DocumentSignedList";
import IdleTimer from "react-idle-timer";
import PageVisibility from "react-page-visibility";
import AccessAllDocuments from "./containers/AccessAllDocuments";
import otherUtils from "./otherUtils";
import CpfValidation from "./containers/CpfValidation";
import HomologBanner from "./components/HomologBanner/HomologBanner";
import NotAuthenticated from "./containers/NotAuthenticated";
//import Rollbar from "rollbar";

var errorsFacetec = require(`./errorsFacetec.js`);

// same configuration you would create for the Rollbar.js SDK
// const rollbarConfig = {
//   accessToken: "a0f4e1eb4deb4874abf6412826a7e976",
//   environment: "production",
// };

// Desabilitar console.log em modo de produção
if (process.env.NODE_ENV === "production") {
  console.log = function () {};
}

// const rollbar = new Rollbar(rollbarConfig);

const delay = (ms) => new Promise((res) => setTimeout(res, ms));
export class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      renderTerms: false,
      renderAuthenticateFace: false,
      renderDocumentViewer: false,
      render404: false,
      render500: false,
      renderDocumentNotSigned: false,
      renderDocumentSigned: false,
      termsUpdate: false,
      termsURL: null,
      termsVersion: null,
      renderRefused: false,
      base64Document: null,
      base64DocumentSigned: false,
      renderLoadingTerm: false,
      renderRegistrationFace: false,
      renderCapture: false,
      renderInconsistencyData: false,
      auditTrail: null,
      renderDocumentIsSigned: false,
      renderInfo: false,
      renderBiometricInvalid: false,
      renderCpfInvalid: false,
      renderDeath: false,
      renderUserBlock: false,
      renderValidationConfirmed: false,
      renderFaceConfirmed: false,
      renderLastVerification: false,
      renderToastVerification: false,
      renderDocumentSignedList: false,
      documentSignedList: null,
      renderSessionExpired: false,
      renderAuthenticationConfirmed: false,
      renderAuthenticationPerfomed: false,
      renderAllDocuments: false,
      renderSelfieInvalid: false,
      renderGeolocationNeeded: false,
      useNotary: null,
      renderDocumentUnsigned: false,
      customMessage: null,
      renderCpfValidation: false,
      cpfValid: null,
      transactionUuid: null,
      lastDocument: false,
      previousDocument: false,
      authToken: null,
      docIds: null,
      currentIdDoc: null,
      externalDatabaseRefID: null,
      existente: null,
      authentication: false,
      keyUrl: this.getParamURL("chave"),
      keyUrlDocs: this.getParamURL("docs"),
      ignoreManutencao: this.getParamURL("ignoreManutencao"),
      debugFront: false,
      inMaintenance: false,
      renderDeletedDoc: false,
      renderExpiredDoc: false,
      renderArrestWarrant: false,
      renderDocBlocked: false,
      renderConnectionInterrupted: false,
      renderCancel: false,
      renderAccessCam: false,
      renderLimitAccess: false,
      urlCallback: this.getParamURL("urlCallback"),
      consentRedirectUrl: null,
      urlCancel: this.getParamURL("urlCancel"),
      keyCallback: this.getKeyCallback(),
      origin: this.getParamURL("origin"),
      altRedirect: this.getParamURL("altRedirect"),
      onlyUrl: this.onlyURL(),
      companyLogo: null,
      helperURL: null,
      footerTitle: null,
      sigla: null,
      currentDocumentPosition: 1,
      frontUuid: null,
      messageWarning: null,
      iconWarning: null,
      authenticationNoDocument: false,
      renderUrlInvalid: false,
      signWithIdrc: null,
      userNeedSeeAllDocsBeforeSign: null,
      idrcLoginUrl: null,
    };

    //CONTROLE EXPIRACAO SESSAO
    this.onIdle = this._onIdle.bind(this);
  }

  getAllStatesFalse() {
    return {
      loading: false,
      renderTerms: false,
      renderAuthenticateFace: false,
      renderDocumentViewer: false,
      render404: false,
      render500: false,
      renderDocumentNotSigned: false,
      renderDocumentSigned: false,
      termsUpdate: false,
      termsURL: null,
      termsVersion: null,
      renderRefused: false,
      base64Document: null,
      base64DocumentSigned: null,
      renderLoadingTerm: false,
      renderRegistrationFace: false,
      renderCapture: false,
      renderInconsistencyData: false,
      auditTrail: null,
      renderDocumentIsSigned: false,
      renderInfo: false,
      renderBiometricInvalid: false,
      renderCpfInvalid: false,
      renderDeath: false,
      renderUserBlock: false,
      renderValidationConfirmed: false,
      renderFaceConfirmed: false,
      renderLastVerification: false,
      renderToastVerification: false,
      renderDocumentSignedList: false,
      documentSignedList: null,
      renderSessionExpired: false,
      renderDeletedDoc: false,
      renderExpiredDoc: false,
      renderArrestWarrant: false,
      renderDocBlocked: false,
      renderConnectionInterrupted: false,
      renderCancel: false,
      renderAccessCam: false,
      renderLimitAccess: false,
      renderAuthenticationConfirmed: false,
      renderAuthenticationPerfomed: false,
      renderAllDocuments: false,
      renderSelfieInvalid: false,
      renderGeolocationNeeded: false,
      useNotary: null,
      currentDocumentPosition: this.state.currentDocumentPosition,
      renderDocumentUnsigned: false,
      customMessage: null,
      renderCpfValidation: false,
      cpfValid: null,
      transactionUuid: null,
      renderUrlInvalid: false,
    };
  }

  intervalID = 0;
  startInterval = (param, _interval) => {
    //param 1 = front image
    //param 2 = back image

    this.intervalID = setInterval(() => {
      if (param === 1) {
        window.ConfiaAudioFront.playFront();
      } else if (param === 2) {
        window.ConfiaAudioBack.playBack();
      }
      this.clearInterval();
      this.startInterval(param, 15000);
    }, _interval);
  };

  clearInterval = () => {
    window.clearInterval(this.intervalID);
  };

  getParamURL = (param) => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    return urlParams.get(param);
  };

  getKeyCallback = () => {
    const queryString = window.location.search;
    const pathName = window.location.pathname;
    const urlParams = new URLSearchParams(queryString);
    const value = urlParams.get("keyCallback");
    return value && pathName === "/allDocuments" ? value : null;
  };

  onlyURL = () => {
    const search = window.location.search;
    const pathName = window.location.pathname;
    return (!search || search == "?ignoreManutencao=true" || search == "?ignoreManutencao=false") && pathName === "/" ? true : false;
  };

  // função que traz a logo da empresa que está usando o assinador
  async loadCompanyLogo(identifier = this.state.keyUrl) {
    let cpnLogo;
    let footerMessage = "Plataforma dos Cartórios";
    let title = "Confia";
    let signWithIdrc = null; // se a assinatura é feita com o IDRC ou não
    // let siglaCompany = "RTDPJ";
    let siglaCompany = "Plataforma de Assinatura";
    let companyHelperURL = process.env.REACT_APP_HELP_URL;
    let userNeedSeeAllDocsBeforeSign = null; // se o botão de assinar deve ser exibido somente no último documento
    try {
      const response = await api.get(`/companyLogo/${identifier}`);
      if (response.status === 200) {
        if (response.data.companyLogo) {
          cpnLogo = `data:image/png;base64,${response.data.companyLogo}`;
        } else {
          cpnLogo = logo;
        }
        title = response.data.title ? response.data.title : title;
        siglaCompany = response.data.sigla ? response.data.sigla : siglaCompany;
        footerMessage = response.data.footerMessage ? response.data.footerMessage : footerMessage;
        companyHelperURL = response.data.helperURL ? response.data.helperURL : companyHelperURL;
        signWithIdrc = response.data.signWithIdrc;
        userNeedSeeAllDocsBeforeSign = !!response.data.userNeedSeeAllDocsBeforeSign;
        if (response.data.favicon) {
          let link = document.querySelector("link[rel~='icon']");
          link.href = `data:image/png;base64,${response.data.favicon}`;
        }
      }
    } catch (err) {
      cpnLogo = logo;
    } finally {
      await this.setState({ companyLogo: cpnLogo, footerTitle: footerMessage, sigla: siglaCompany, helperURL: companyHelperURL, signWithIdrc: signWithIdrc, userNeedSeeAllDocsBeforeSign: userNeedSeeAllDocsBeforeSign });
      document.title = title;
    }
  }

  async componentDidMount() {
    if (window.location.pathname === "/not-authenticated") {
      return;
    }
    await fetch(process.env.REACT_APP_API_URL + "/api/status");
    if (this.state.keyUrl) {
      if (!validate(this.state.keyUrl)) {
        this.setState({ render404: true }); // link inválido
        return;
      }
      await this.loadCompanyLogo();
    } else if (this.state.keyUrlDocs) {
      await this.loadCompanyLogo(this.state.keyUrlDocs);
    }
    if (this.state.ignoreManutencao && this.state.ignoreManutencao === "true") {
      this.loadAfterMaintenance();
    } else {
      try {
        //CASO VOLTE O CÓDIGO 106 QUE SIGNIFICA QUE ESTÁ EM MANUTENÇÃO, O SERVIÇO JÁ DEVOLVE UMA EXCEPTION QUE CAÍ NO CATCH E É TRATADA.
        await api.get(`/checkSystemStatus`);
        this.loadAfterMaintenance();
      } catch (error) {
        this.onError(error);
      }
    }
  }

  loadAfterMaintenance = async () => {
    if (this.state.onlyUrl || this.state.keyCallback) {
      this.setState({ renderAllDocuments: true });
      //this.setState({ render404: true });
    } else {
      this.setState({ loading: true });
      if (this.state.keyUrlDocs) {
        this.getListDocuments();
      } else {
        try {
          if (!this.state.renderCpfValidation) {
            let response = await api.get(`/featureCompany/${this.state.keyUrl}`);
            if (response.data.code === 0) {
              try {
                response = JSON.parse(otherUtils.decryptData(response.data.features));
              } catch (error) {
                console.log("error decrypt");
                this.setState(this.getAllStatesFalse());
                this.setState({ render500: true });
                return;
              }

              if (response.cpfConfirmationSign) {
                this.setState(this.getAllStatesFalse());
                this.setState({ renderCpfValidation: true, cpfValid: response.cpf });
                return;
              }
            }
          }
        } catch (err) {
          this.onError(err);
        }

        var position = null;
        try {
          position = await this.getLongAndLat();
        } catch (error) {
          console.log(error.message);
        }
        if (!position || !position.coords || position.coords.latitude == null || position.coords.longitude == null) {
          position = null;
          try {
            //CASO RETORNE ALGUM ERRO, O SERVIÇO JÁ DEVOLVE UMA EXCEPTION QUE CAÍ NO CATCH E É TRATADA PELO CÓDIGO DE RETORNO.
            await api.get(`/checkFeatureCompany/${this.state.keyUrl}`);
          } catch (err) {
            await this.onError(err);
          }
        }
        if (position) {
          try {
            position.address = await this.getAddressByLatLong(position);
          } catch (error) {
            console.log(error.message);
          }
        }
        if (!this.state.renderGeolocationNeeded) {
          if (!this.state.signWithIdrc) {
            var count = 0;
            var initalized = window.ConfiaApp.getInitializedStatus();
            //Espera inicialização dos scripts facetec
            while (!initalized) {
              await delay(200);
              initalized = window.ConfiaApp.getInitializedStatus();
              count += 1;
              //console.log(count)
              if (count >= 600) {
                // 1 minuto e facetec não respondeu --> mostra erro
                this.setState(this.getAllStatesFalse());
                this.setState({ render500: true });
                break;
              }
            }
            if (initalized) {
              await this.loadProcessInitial(position);
            }
          } else {
            await this.loadProcessInitial(position);
          }
        }
      }
    }
  };

  getLongAndLat = () => {
    if (navigator.geolocation) {
      return new Promise((resolve, reject) => navigator.geolocation.getCurrentPosition(resolve, reject));
    } else {
      console.error("Geolocation is not supported by this Browser/OS.");
    }
  };

  getAddressByLatLong = async (position) => {
    try {
      const response = await fetch(`https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${position.coords.latitude}&longitude=${position.coords.longitude}&localityLanguage=pt-br`);
      if (response.ok) {
        const res = await response.json();
        return `${res.locality} - ${res.city ? res.city : res.principalSubdivision}`;
      } else {
        return "";
      }
    } catch (error) {
      console.error("Error by Geolocation.");
    }
  };

  getListDocuments = async () => {
    this.setState(this.getAllStatesFalse());
    this.setState({ loading: true });
    try {
      var response = await api.get(`/signedDocumentList/${this.state.keyUrlDocs}`);

      this.setState(this.getAllStatesFalse());
      this.setState({
        renderDocumentSignedList: true,
        documentSignedList: response.data.document,
        debugFront: response.data.debugFront,
        useNotary: response.data.useNotary,
      });
      this.handleRollbar(response);
    } catch (error) {
      this.onError(error);
    }
  };

  loadProcessInitial = async (paramPosition) => {
    this.setState(this.getAllStatesFalse());
    this.setState({ loading: true });
    if (!this.state.keyUrl) {
      this.setState(this.getAllStatesFalse());
      this.setState({ render404: true });
    } else {
      try {
        var latlong = paramPosition ? `${paramPosition.coords.latitude},${paramPosition.coords.longitude}` : null;
        var address = paramPosition ? paramPosition.address : null;

        var response = await api.post(`/start/${this.state.keyUrl}`, {
          latlong,
          address,
          origin: this.state.origin,
          originalUrl: window.location.href,
        });
        this.setState(this.getAllStatesFalse());
        if (response.data.idrcAuthenticated) {
          this.onDisplayDocument(response.data.authToken, response.data.docIds);
        } else {
          this.setState({
            existente: response.data.existente,
            externalDatabaseRefID: response.data.identifier,
            authentication: response.data.authentication,
            debugFront: response.data.debugFront,
            frontUuid: Math.floor(100000 + Math.random() * 900000),
            messageWarning: response.data.messageWarning,
            iconWarning: response.data.iconWarning ? `data:image/png;base64,${response.data.iconWarning}` : null,
            authenticationNoDocument: response.data.authenticationNoDocument,
            idrcLoginUrl: response.data.idrcLoginUrl,
          });
          this.handleRollbar(response);
          if (response.data.termsURL) {
            this.setState(this.getAllStatesFalse());
            this.setState({
              termsVersion: response.data.termsVersion,
              renderTerms: true,
              termsUpdate: response.data.termsUpdate,
              termsURL: response.data.termsURL,
            });
          } else {
            var lastVerification = response.data.numTries == response.data.maxTries - 1 ? true : false;
            if (this.state.signWithIdrc) {
              window.location.replace(this.state.idrcLoginUrl);
              // alert("Chamou o start e deve redirecionar para IDRC");
            } else {
              this.onExecuteFacetec(lastVerification);
            }
          }
        }
      } catch (error) {
        this.onError(error);
      }
    }
  };

  onTermsAcceptSuccess = (param) => {
    if (param.accept) {
      var requestRollbar = {
        apiPost: `/acceptTerms/${this.state.keyUrl}`,
        termsVersion: this.state.termsVersion,
      };
      this.handleRollbar(requestRollbar);

      api
        .post(`/acceptTerms/${this.state.keyUrl}`, {
          termsVersion: this.state.termsVersion,
        })
        .then((response) => {
          this.handleRollbar(response);
          if (this.state.signWithIdrc) {
            window.location.replace(this.state.idrcLoginUrl);
          } else {
            this.onExecuteFacetec();
          }
        })
        .catch((error) => {
          this.onError(error);
        });
    } else {
      this.setState({ renderRefused: true, renderTerms: false });
    }
  };

  onAcceptInfo = () => {
    localStorage.removeItem("processMatch");
    this.setState(this.getAllStatesFalse());
    this.setState({ renderRegistrationFace: true });
  };

  onExecuteFacetec = (lastVerification) => {
    this.setState(this.getAllStatesFalse());
    if (this.state.existente) {
      if (lastVerification) {
        this.setState({ renderLastVerification: lastVerification });
      } else if (this.state.messageWarning) {
        this.setState({ renderInfo: true });
      } else {
        this.setState({ renderAuthenticateFace: true });
      }
    } else {
      this.setState({
        renderInfo: true,
        renderToastVerification: lastVerification,
      });
    }
  };

  onAuthenticateFaceSuccess = (response) => {
    if (response.code) {
      this.onError(response);
    } else {
      if (!this.state.authentication) {
        this.onDisplayDocument(response.authToken, response.docIds);
      } else {
        this.processAuthenticate();
      }
    }
  };

  onRegistrationFaceSuccess = async (response) => {
    if (response.code == 104 || response.code == 0) {
      if (response.authToken) {
        if (this.state.authentication) {
          this.processAuthenticate();
        } else {
          this.setState(this.getAllStatesFalse());
          this.setState({ renderValidationConfirmed: true });
          await delay(2000);
          this.onDisplayDocument(response.authToken, response.docIds);
        }
      } else {
        this.setState(this.getAllStatesFalse());
        this.setState({
          renderCapture: true,
          auditTrail: response.auditTrail,
          transactionUuid: response.transactionUuid,
        });
      }
    } else {
      this.onError(response);
    }
  };

  onDisplayDocument = async (authToken, docIds) => {
    this.setState(this.getAllStatesFalse());
    this.setState({
      renderFaceConfirmed: true,
      docIds: docIds,
      authToken: authToken,
    });
    await delay(3000);
    if (this.state.docIds.length === 1) {
      this.setState({
        currentIdDoc: this.state.docIds[0],
        lastDocument: true,
        previousDocument: null,
      });
    } else {
      this.setState({ currentIdDoc: this.state.docIds[0] });
    }
    this.getDocument();
  };

  nextDocument = async () => {
    this.setState(this.getAllStatesFalse());
    this.setState({ renderFaceConfirmed: true });
    await delay(500);
    var indexAtual = this.state.docIds.indexOf(this.state.currentIdDoc);
    var proximoIndex = indexAtual + 1;
    if (this.state.docIds.length > proximoIndex + 1) {
      this.setState({
        currentDocumentPosition: proximoIndex + 1,
        currentIdDoc: this.state.docIds[proximoIndex],
        previousDocument: true,
      });
    } else if (this.state.docIds.length === proximoIndex + 1) {
      this.setState({
        currentDocumentPosition: this.state.docIds.length,
        currentIdDoc: this.state.docIds[proximoIndex],
        previousDocument: true,
        lastDocument: true,
      });
    }
    this.getDocument();
  };

  returnDocumentPrevious = async () => {
    this.setState(this.getAllStatesFalse());
    this.setState({ renderFaceConfirmed: true });
    await delay(500);
    var indexAtual = this.state.docIds.indexOf(this.state.currentIdDoc);
    var indexAnterior = indexAtual - 1;
    if (indexAnterior > 0) {
      this.setState({
        currentDocumentPosition: indexAnterior + 1,
        currentIdDoc: this.state.docIds[indexAnterior],
        previousDocument: true,
        lastDocument: false,
      });
    } else if (indexAnterior === 0) {
      this.setState({
        currentDocumentPosition: 1,
        currentIdDoc: this.state.docIds[indexAnterior],
        previousDocument: false,
        lastDocument: false,
      });
    }
    this.getDocument();
  };

  handlePdfFile = (pdfBase64) => {
    const pdfBuffer = Buffer.from(pdfBase64, "base64");
    // Criar URL temporária para o Buffer
    const pdfUrl = URL.createObjectURL(new Blob([pdfBuffer], { type: "application/pdf" }));

    return pdfUrl;
  };
  getDocument = () => {
    var requestRollbar = {
      apiGet: `/documentToSign/${this.state.keyUrl}?docId=${this.state.currentIdDoc}`,
    };
    this.handleRollbar(requestRollbar);

    api
      .get(`/documentToSign/${this.state.keyUrl}?docId=${this.state.currentIdDoc}`)
      .then(async (response) => {
        let currenteDocument = await this.handlePdfFile(response.data.document);
        this.handleRollbar(response);
        this.setState(this.getAllStatesFalse());
        this.setState({
          base64Document: currenteDocument,
          renderDocumentViewer: true,
        });
      })
      .catch((error) => {
        this.onError(error);
      });
  };

  onSignOrNotSign = async (param) => {
    if (this.state.urlCallback) {
      this.setState({
        urlCallback: this.state.urlCallback.includes("?") ? this.state.urlCallback + `&keyCallback=${this.state.keyUrl}` : this.state.urlCallback + `?keyCallback=${this.state.keyUrl}`,
      });
    }
    if (param.signed) {
      this.setState(this.getAllStatesFalse());
      this.setState({ renderLoadingTerm: true });
      var position = null;
      try {
        position = await this.getLongAndLat();
      } catch (error) {
        console.log(error.message);
      }
      if (!position || !position.coords || position.coords.latitude == null || position.coords.longitude == null) {
        position = null;
        try {
          //CASO RETORNE ALGUM ERRO, O SERVIÇO JÁ DEVOLVE UMA EXCEPTION QUE CAÍ NO CATCH E É TRATADA PELO CÓDIGO DE RETORNO.
          await api.get(`/checkFeatureCompany/${this.state.keyUrl}`);
        } catch (err) {
          await this.onError(err);
        }
      }
      if (position) {
        try {
          position.address = await this.getAddressByLatLong(position);
        } catch (error) {
          console.log(error.message);
        }
      }

      if (!this.state.renderGeolocationNeeded) {
        var requestRollbar = {
          apiPost: `/signDocument/${this.state.keyUrl}`,
          authToken: this.state.authToken,
        };
        this.handleRollbar(requestRollbar);

        var latParam = null;
        var longParam = null;
        var altParam = null;
        var address = null;

        if (position) {
          latParam = position.coords.latitude;
          longParam = position.coords.longitude;
          altParam = position.coords.altitude;
          address = position.address;
        }

        api
          .post(`/signDocument/${this.state.keyUrl}`, {
            authToken: this.state.authToken,
            latitude: latParam,
            longitude: longParam,
            altitude: altParam,
            address: address,
          })
          .then((response) => {
            this.handleRollbar(response);

            if (response.data.consentSessionId) {
              let consentUrl = `${process.env.REACT_APP_CONSENT_URL}/${response.data.consentSessionId}`;
              if (this.state.urlCallback) {
                consentUrl += `?urlCallback=${encodeURIComponent(this.state.urlCallback)}`;
              }
              this.setState({ consentRedirectUrl: consentUrl });
            }

            if (response.data.docSignedFull) {
              this.setState(this.getAllStatesFalse());
              this.setState({
                renderDocumentSigned: true,
                base64DocumentSigned: true,
              });
            } else {
              this.setState({ renderDocumentSigned: true });
            }
          })
          .catch((error) => {
            this.onError(error);
          });
      }
    } else {
      try {
        const response = await api.post(`/unsignedDocument/${this.state.keyUrl}`, {
          authToken: this.state.authToken,
          refusedReason: param.refusedReason,
        });

        if (response.status !== 200) {
          throw "Erro ao gravar o logAduit da  recusa de assinatura";
        }
      } catch (err) {}
      this.setState({
        renderDocumentUnsigned: true,
      });
    }
  };

  documentNotSigned = () => {
    this.setState({
      renderDocumentNotSigned: true,
      renderDocumentViewer: false,
    });
  };

  onBackTerms = () => {
    this.setState({ renderRefused: false, renderTerms: true });
  };

  onBackSigned = async () => {
    this.setState(this.getAllStatesFalse());
    this.setState({ renderFaceConfirmed: true });
    await delay(500);
    if (this.state.docIds.length === 1) {
      this.setState({
        currentIdDoc: this.state.docIds[0],
        lastDocument: true,
        previousDocument: null,
      });
    } else {
      this.setState({
        currentIdDoc: this.state.docIds[0],
        lastDocument: false,
        previousDocument: false,
      });
    }
    this.getDocument();
  };

  onSignSuccess = () => {
    this.setState(this.getAllStatesFalse());
    this.setState({ renderTerms: true });
  };

  onCaptureSuccess = async (authToken, docIds) => {
    this.setState(this.getAllStatesFalse());
    this.setState({ renderValidationConfirmed: true });
    if (!this.state.authentication) {
      await delay(2000);
      this.onDisplayDocument(authToken, docIds);
    } else {
      this.processAuthenticate();
    }
  };

  continueVerification = () => {
    this.setState(this.getAllStatesFalse());
    this.onExecuteFacetec();
  };

  continueVerificationWarn = () => {
    this.setState({ messageWarning: null, iconWarning: null }, () => {
      this.onExecuteFacetec();
    });
  };

  loadPage = async () => {
    if (this.state.keyUrlDocs) {
      this.getListDocuments();
    } else {
      // Esses 2 states nao podem ficar no getAllStatesFalse pq no proximo ou anterior document eles nao podem ser limpos,
      // so devem ser limpos no caso de erro 500 pra chegarem certo no documento
      this.setState({
        lastDocument: false,
        previousDocument: false,
      });

      var position = null;
      try {
        position = await this.getLongAndLat();
      } catch (error) {
        console.log(error.message);
      }
      if (!position || !position.coords || position.coords.latitude == null || position.coords.longitude == null) {
        position = null;
        try {
          //CASO RETORNE ALGUM ERRO, O SERVIÇO JÁ DEVOLVE UMA EXCEPTION QUE CAÍ NO CATCH E É TRATADA PELO CÓDIGO DE RETORNO.
          await api.get(`/checkFeatureCompany/${this.state.keyUrl}`);
        } catch (err) {
          await this.onError(err);
        }
      }
      if (position) {
        try {
          position.address = await this.getAddressByLatLong(position);
        } catch (error) {
          console.log(error.message);
        }
      }
      if (!this.state.renderGeolocationNeeded) {
        this.loadProcessInitial(position);
      }
    }
  };

  onError = async (error) => {
    this.handleRollbar(error);
    this.setState(this.getAllStatesFalse());

    if (this.state.urlCallback) {
      this.setState({
        urlCallback: this.state.urlCallback.includes("?") ? this.state.urlCallback + `&keyCallback=${this.state.keyUrl}` : this.state.urlCallback + `?keyCallback=${this.state.keyUrl}`,
      });
    }

    if (error.statusErrorFacetec) {
      //TRATAMENTO ERROS INTERNOS FACETEC
      let statusErro = errorsFacetec.recuperaErros();
      let logAuditoria = {
        identifier: this.state.keyUrl,
      };
      if (statusErro[error.statusErrorFacetec]) {
        logAuditoria.mensagem = statusErro[error.statusErrorFacetec].msgTraduzida;
        logAuditoria.privado = statusErro[error.statusErrorFacetec].privado;
        logAuditoria.codigo = statusErro[error.statusErrorFacetec].codigo;
        this.setState({ [statusErro[error.statusErrorFacetec].renderRedirect]: true });
      } else {
        logAuditoria.mensagem = `Código não definido - ${error.statusErrorFacetec}`;
        logAuditoria.privado = 1;
        this.setState({ render500: true });
      }
      await api.post(`/logAuditoria`, logAuditoria);
      if (this.state.urlCancel) {
        await api.put(`/cancelaAutenticacao/${this.state.keyUrl}`);
      }
    } else {
      if (!error.response && error.code) {
        error.response = new Object();
        error.response.data = new Object();
        error.response.data.code = error.code;
        delete error.code;
      }
      if (error && error.response && error.response.data && error.response.data.code) {
        /*   --- CODIGOS RETORNOS ---
       90 = ERRO INESPERADO - PAGE ERRO 500
       91 = TRANSACAO INVÁLIDA - PAGE ERRO 404
       92 = DOCUMENTO JÁ ASSINADO
       93 = CLIENTE NÃO ENCONTRADO - PAGE ERRO 404
       94 = DOCUMENTO NÃO ENCONTRADO - PAGE ERRO 404
       95 = DADOS INCOSISTENTES - PAGE DADOS INCOSISTENTES
       96 = RECAPTURA IMAGEM DO DOCUMENTO
       *** 97 = NÃO FOI POSSÍVEL REALIZAR OCR DO DOCUMENTO ***
       98 = BIOMETRIA INVALIDA --
       99 = CPF INVÁLIDO --
       100 = OBITO
       101 = BLOQUEADO
       103 = DOCUMENTO EXCLUÍDO, RECUSADO OU INATIVO
       *** 104 = CAPTURAR RG *** 
       105 = IMAGEM DA SELFIE INVALIDA 
       106 = SISTEMA EM MANUTENÇÃO 
       109 = CAPTURA OBRIGATÓRIA DA GEOLOCALIZAÇÃO
       110 = DOCUMENTO EXPIRADO
       111 = MANDADO DE PRISÃO IDENTIFICADO
       112 = MANDADO DE PRISÃO IDENTIFICADO*/
        if (error.response.data.code === 92) {
          this.setState({ renderDocumentIsSigned: true });
        } else if ([91, 93, 94].indexOf(error.response.data.code) >= 0) {
          this.setState({ render404: true });
        } else if (error.response.data.code === 95) {
          this.setState({ renderInconsistencyData: true });
        } else if (error.response.data.code === 98) {
          this.setState({ renderBiometricInvalid: true, customMessage: error.customMessage });
        } else if (error.response.data.code === 99) {
          this.setState({ renderCpfInvalid: true });
        } else if (error.response.data.code === 100) {
          this.setState({ renderDeath: true });
        } else if (error.response.data.code === 101) {
          this.setState({ renderUserBlock: true });
        } else if (error.response.data.code === 102) {
          this.setState({ renderAuthenticationPerfomed: true });
        } else if (error.response.data.code === 103) {
          this.setState({ renderDeletedDoc: true });
        } else if (error.response.data.code === 105) {
          this.setState({ renderSelfieInvalid: true });
        } else if (error.response.data.code === 106) {
          this.setState({ inMaintenance: true });
        } else if (error.response.data.code === 109) {
          this.setState({ renderGeolocationNeeded: true });
        } else if (error.response.data.code === 110) {
          this.setState({ renderExpiredDoc: true });
        } else if (error.response.data.code === 111) {
          this.setState({ renderArrestWarrant: true });
        } else if (error.response.data.code === 112) {
          this.setState({ renderDocBlocked: true });
        } else if (error.response.data.code === 113) {
          this.setState({ renderArrestWarrant: true });
        } else if (error.response.data.code === 114) {
          this.setState({ renderPep: true });
        } else if (error.response.data.code === 115) {
          this.setState({ renderUrlInvalid: true });
        } else {
          this.setState({ render500: true });
        }
      } else {
        this.setState({ render500: true });
      }
    }
  };

  /* INICIO CONTROLE INATIVIDADE */

  _onIdle(e) {
    this.setState(this.getAllStatesFalse());
    this.setState({ renderSessionExpired: true });
    window.ConfiaAudioBack.stopBack();
    window.ConfiaAudioFront.stopFront();
    this.clearInterval();
  }

  /* FIM CONTROLE INATIVIDADE */

  handleVisibilityChange = (isVisible) => {
    if (!isVisible) {
      window.ConfiaAudioBack.stopBack();
      window.ConfiaAudioFront.stopFront();
      this.clearInterval();
    }
  };

  processAuthenticate = async () => {
    this.setState(this.getAllStatesFalse());
    this.setState({ renderAuthenticationConfirmed: true });
    if (this.state.urlCallback) {
      this.setState({
        urlCallback: this.state.urlCallback.includes("?") ? this.state.urlCallback + `&keyCallback=${this.state.keyUrl}` : this.state.urlCallback + `?keyCallback=${this.state.keyUrl}`,
      });
    }
  };

  handleRollbar = (params) => {
    // if (this.state.debugFront) {
    //   if (this.state.keyUrl) {
    //     rollbar.info(this.state.keyUrl, params);
    //   } else {
    //     rollbar.info(this.state.keyUrlDocs, params);
    //   }
    // }
  };

  handleCancel = async () => {
    await api.put(`/cancelaAutenticacao/${this.state.keyUrl}`);
    window.location.replace(this.state.urlCancel);
  };

  render() {
    if (window.location.pathname === "/not-authenticated") {
      return (
        <>
          <HomologBanner />
          <NotAuthenticated />
        </>
      );
    }
    return (
      <>
        <HomologBanner />
        {!this.state.renderCancel && this.state.urlCancel && (
          <div className="row mt-5 justify-content-center">
            <div className="col-1 d-grid" style={{ position: "fixed", top: "10px", zIndex: "9500", right: "10%" }}>
              <button type="button" className="btn-sm" style={{ backgroundColor: "#fff" }} onClick={() => this.handleCancel()}>
                <img src={btnx} alt="buttonpng" border="0" style={{ width: 36, height: 36 }} />
              </button>
            </div>
          </div>
        )}

        {!this.state.renderAuthenticateFace &&
          !this.state.renderRegistrationFace &&
          !this.state.render404 &&
          !this.state.render500 &&
          !this.state.renderInconsistencyData &&
          !this.state.renderBiometricInvalid &&
          !this.state.renderCpfInvalid &&
          !this.state.renderDeath &&
          !this.state.renderUserBlock &&
          !this.state.renderSessionExpired &&
          !this.state.renderDocumentSignedList &&
          !this.state.renderDocumentIsSigned &&
          !this.state.renderDocumentSigned &&
          !this.state.renderAuthenticationConfirmed &&
          !this.state.renderAuthenticationPerfomed &&
          !this.state.renderAllDocuments &&
          !this.state.inMaintenance &&
          !this.state.renderDeletedDoc &&
          !this.state.renderExpiredDoc &&
          !this.state.renderArrestWarrant &&
          !this.state.renderPep &&
          !this.state.renderDocBlocked &&
          !this.state.renderSelfieInvalid &&
          !this.state.renderConnectionInterrupted &&
          !this.state.renderCancel &&
          !this.state.renderAccessCam &&
          !this.state.renderLimitAccess &&
          !this.state.renderGeolocationNeeded &&
          !this.state.renderDocumentUnsigned &&
          !this.state.renderUrlInvalid && (
            <>
              <IdleTimer
                ref={(ref) => {
                  this.idleTimer = ref;
                }}
                element={document}
                onIdle={this.onIdle}
                debounce={250}
                timeout={100000 * 3} //5 MINUTOS
              />
            </>
          )}
        {this.state.inMaintenance ? (
          <ErrorGeneric inMaintenance={true} logo={this.state.companyLogo} />
        ) : this.state.loading ? (
          <Loading logo={this.state.companyLogo} footerMessage={this.state.footerTitle} />
        ) : this.state.render404 ? (
          <Page404 />
        ) : this.state.render500 ? (
          <Page500 onLoadProcess={this.loadPage} logo={this.state.companyLogo} />
        ) : this.state.renderRefused ? (
          <Refused onBack={this.onBackTerms} />
        ) : this.state.renderTerms ? (
          <Terms onAccept={this.onTermsAcceptSuccess} termsUpdate={this.state.termsUpdate} termsURL={this.state.termsURL} logo={this.state.companyLogo} sigla={this.state.sigla} />
        ) : this.state.renderAuthenticateFace ? (
          <AuthenticateFace
            onSuccess={this.onAuthenticateFaceSuccess}
            onError={this.onError}
            externalDatabaseRefID={this.state.externalDatabaseRefID}
            identifier={this.state.keyUrl}
            frontUuid={this.state.frontUuid}
          />
        ) : this.state.renderDocumentNotSigned ? (
          <DocumentNotSigned onBack={this.onBackSigned} notSign={this.onSignOrNotSign} documentUnsigned={this.state.renderDocumentUnsigned} />
        ) : this.state.renderDocumentViewer ? (
          <DocumentViewer
            lastDocument={this.state.lastDocument}
            previousDocument={this.state.previousDocument}
            base64={this.state.base64Document}
            onSign={this.onSignOrNotSign}
            returnDocumentPrevious={this.returnDocumentPrevious}
            nextDocument={this.nextDocument}
            amountOfDocuments={this.state.docIds?.length || 1}
            currentDocumentPosition={this.state.currentDocumentPosition}
            documentNotSigned={this.documentNotSigned}
            userNeedSeeAllDocsBeforeSign={this.state.userNeedSeeAllDocsBeforeSign}
          />
        ) : this.state.renderDocumentSigned ? (
          <DocumentSigned exibDownload={this.state.base64DocumentSigned} identifier={this.state.keyUrl} urlRedirect={this.state.consentRedirectUrl || this.state.urlCallback} logo={this.state.companyLogo} />
        ) : this.state.renderLoadingTerm ? (
          <LoadingTerm logo={this.state.companyLogo} />
        ) : this.state.renderRegistrationFace ? (
          <RegistrationFace
            onSuccess={this.onRegistrationFaceSuccess}
            onError={this.onError}
            externalDatabaseRefID={this.state.externalDatabaseRefID}
            identifier={this.state.keyUrl}
            frontUuid={this.state.frontUuid}
          />
        ) : this.state.renderCapture ? (
          <>
            <PageVisibility onChange={this.handleVisibilityChange} />
            <Capture
              companyHelperURL={this.state.helperURL}
              logo={this.state.companyLogo}
              onSuccess={this.onCaptureSuccess}
              onError={this.onError}
              identifier={this.state.keyUrl}
              imagesAuditTrail={this.state.auditTrail}
              funStartInterval={this.startInterval}
              funClearInterval={this.clearInterval}
              funRollbar={this.handleRollbar}
              externalDatabaseRefID={this.state.externalDatabaseRefID}
              transactionUuid={this.state.transactionUuid}
            />
          </>
        ) : this.state.renderInconsistencyData ? (
          <ErrorGeneric dataInvalid={true} urlRedirect={this.state.urlCallback} authentication={this.state.authentication} logo={this.state.companyLogo} />
        ) : this.state.renderDocumentIsSigned ? (
          <DocumentIsSigned urlRedirect={this.state.urlCallback} />
        ) : this.state.renderInfo ? (
          <Info
            onClick={this.onAcceptInfo}
            infoBlocked={this.state.renderToastVerification}
            authenticationNoDocument={this.state.authenticationNoDocument}
            continueVerification={this.continueVerificationWarn}
            existente={this.state.existente}
            messageWarning={this.state.messageWarning}
            logo={this.state.iconWarning ? this.state.iconWarning : this.state.companyLogo}
          />
        ) : this.state.renderBiometricInvalid ? (
          <ErrorGeneric
            biometricInvalid={true}
            urlRedirect={this.state.urlCallback}
            authentication={this.state.authentication}
            customMessage={this.state.customMessage}
            logo={this.state.companyLogo}
          />
        ) : this.state.renderCpfInvalid ? (
          <ErrorGeneric cpfInvalid={true} urlRedirect={this.state.urlCallback} authentication={this.state.authentication} logo={this.state.companyLogo} />
        ) : this.state.renderDeath ? (
          <ErrorGeneric death={true} urlRedirect={this.state.urlCallback} authentication={this.state.authentication} logo={this.state.companyLogo} />
        ) : this.state.renderDeletedDoc ? (
          <ErrorGeneric deletedDoc={true} logo={this.state.companyLogo} />
        ) : this.state.renderExpiredDoc ? (
          <ErrorGeneric expiredDoc={true} logo={this.state.companyLogo} />
        ) : this.state.renderArrestWarrant ? (
          <ErrorGeneric arrestWarrant={true} logo={this.state.companyLogo} />
        ) : this.state.renderPep ? (
          <ErrorGeneric personPoliticallyExports={true} logo={this.state.companyLogo} />
        ) : this.state.renderDocBlocked ? (
          <ErrorGeneric docBlocked={true} logo={this.state.companyLogo} />
        ) : this.state.renderUserBlock ? (
          <ErrorGeneric block={true} urlRedirect={this.state.urlCallback} authentication={this.state.authentication} logo={this.state.companyLogo} />
        ) : this.state.renderLastVerification ? (
          <ErrorGeneric lastVerification={true} continueVerification={this.continueVerification} logo={this.state.companyLogo} />
        ) : this.state.renderSelfieInvalid ? (
          <ErrorGeneric selfieInvalid={true} urlRedirect={this.state.urlCallback} authentication={this.state.authentication} reloadSystem={this.loadPage} logo={this.state.companyLogo} />
        ) : this.state.renderSessionExpired ? (
          <ErrorGeneric sessionExpired={true} reloadSystem={this.loadPage} logo={this.state.companyLogo} />
        ) : this.state.renderAuthenticationPerfomed ? (
          <ErrorGeneric authenticationNotPermited={true} logo={this.state.companyLogo} urlRedirect={this.state.urlCallback} keyCallback={this.state.keyUrl} />
        ) : this.state.renderConnectionInterrupted ? (
          <ErrorGeneric connectionInterrupted={true} reloadSystem={this.loadPage} logo={this.state.companyLogo} />
        ) : this.state.renderCancel ? (
          <ErrorGeneric cancel={true} urlRedirect={this.state.urlCancel} reloadSystem={this.loadPage} logo={this.state.companyLogo} />
        ) : this.state.renderAccessCam ? (
          <ErrorGeneric accessCam={true} reloadSystem={this.loadPage} logo={this.state.companyLogo} />
        ) : this.state.renderLimitAccess ? (
          <ErrorGeneric limitAccess={true} reloadSystem={this.loadPage} logo={this.state.companyLogo} />
        ) : this.state.renderGeolocationNeeded ? (
          <ErrorGeneric geolocationNeeded={true} logo={this.state.companyLogo} />
        ) : this.state.renderUrlInvalid ? (
          <ErrorGeneric urlInvalid={true} logo={this.state.companyLogo} urlRedirect={this.state.altRedirect} />
        ) : this.state.renderValidationConfirmed ? (
          <ValidationConfirmed registryOk={true} />
        ) : this.state.renderFaceConfirmed ? (
          <ValidationConfirmed faceOk={true} />
        ) : this.state.renderDocumentSignedList ? (
          <DocumentSignedList
            doc={this.state.documentSignedList}
            identifier={this.state.keyUrlDocs}
            onError={this.onError}
            funRollbar={this.handleRollbar}
            useNotary={this.state.useNotary}
            logo={this.state.companyLogo}
          />
        ) : this.state.renderAuthenticationConfirmed ? (
          <ValidationConfirmed urlRedirect={this.state.urlCallback} authentication={this.state.authentication} keyCallback={this.state.keyUrl} />
        ) : this.state.renderAllDocuments ? (
          <AccessAllDocuments keyCallback={this.state.keyCallback} logo={this.state.companyLogo} />
        ) : this.state.renderCpfValidation ? (
          <CpfValidation cpf={this.state.cpfValid} success={this.loadAfterMaintenance} />
        ) : (
          <div />
        )}
      </>
    );
  }
}

export default App;
